import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashpageComponent } from './splashpage.component';
import { ViewOneComponent } from './views/viewOne/viewOne.component';
import { ViewTwoComponent } from './views/viewTwo/viewTwo.component';
import { ViewThreeComponent } from './views/viewThree/viewThree.component';
import { ViewFourComponent } from './views/viewFour/viewFour.component';
import { MaterialModule } from 'src/app/shared/material-module';
import { ViewFiveComponent } from './views/viewFive/viewFive.component';
import { CoreModule } from 'src/app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    CoreModule
  ],
  exports: [
    ViewOneComponent,
    ViewTwoComponent,
    ViewThreeComponent,
    ViewFourComponent,
    SplashpageComponent
  ],
  declarations: [
    SplashpageComponent,
    ViewOneComponent,
    ViewTwoComponent,
    ViewThreeComponent,
    ViewFourComponent,
    ViewFiveComponent],
})
export class SplashpageModule { }
